import type { TFunction } from 'i18next';
import { injectable, inject } from 'tsyringe';

export const TOKEN_IWrapTranslations = Symbol('IWrapTranslations');

/**
 * Service that wraps i18next translation functionality.
 */
export interface IWrapTranslations {
    /**
     * Translates a key to the current language
     * @param key The translation key 
     * @param params Optional parameters for interpolation
     * @returns The translated string
     */
    t(key: string, params?: Record<string, unknown>): string;
}

@injectable()
export class WrapTranslations implements IWrapTranslations {
    constructor(
        @inject("TFunction") private _t: TFunction
    ) { }

    public t = (key: string, params?: Record<string, unknown>): string => {
        return this._t(key, params);
    }
}